module.exports = __webpack_public_path__ + "img/mazda-more-padding.12ff2500.png";